import React from 'react'
import Logo from '../../images/Content/logo.png';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import "../NavBar/NavBar.css";
import { LinkContainer } from "react-router-bootstrap";
import 'animate.css/animate.min.css';


const NavBar = () => {
  return (
    
<Navbar expand="lg" className="bg-body-tertiary navfont"  bg="dark" data-bs-theme="dark">
      <Container>
        
      <LinkContainer to="/Home">
        <Navbar.Brand to="Home"><img className='logo' src={Logo} alt='Logo' /></Navbar.Brand>
        </LinkContainer>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
          <LinkContainer to="Home"> 
            <Nav.Link className="bt bt-underline" href="#home">Inicio</Nav.Link>
            </LinkContainer>  
            <LinkContainer to="About"> 
            <Nav.Link className='bt bt-underline' href="#link">Acerca de nosotros</Nav.Link>
            </LinkContainer>
            <LinkContainer to="Servicios"> 
            <Nav.Link className='bt bt-underline' href="#link">Servicios</Nav.Link>
            </LinkContainer> 
            <LinkContainer to="Proyectos"> 
            <Nav.Link className='bt bt-underline' href="#link">Proyectos</Nav.Link>
            </LinkContainer>
            <LinkContainer to="Contacto"> 
            <Nav.Link className='bt bt-underline' href="#link">Contacto</Nav.Link>
            </LinkContainer>
            <Navbar.Brand className='welcome'>Bienvenido a NinnoTech!</Navbar.Brand>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>


  )
}

export default NavBar